import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ItemCategoriesDto } from "./item-categories.dto";

export class ItemCategoryResponse extends GlobalResponseObject{
      data?: ItemCategoriesDto;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, intlCode:number, internalMessage:string, data?: ItemCategoriesDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.internalMessage = internalMessage;
        this.intlCode = intlCode;
        this.data = data;
    }

}